import React from 'react';
import styled from 'styled-components';
import { Link } from '@reach/router';
import { url } from 'js/services/Network';
import { greyColor } from 'js/config/style';

const Container = styled.div`
  margin-top: 2rem;
  text-align: center;
  font-size: 0.8rem;
  color: ${greyColor.darken().hex()};
`;

export default () => (
  <Container>
    By using PayOnDelivery, you agree to our <Link to={url('terms-and-conditions-page')}>Terms of Service</Link>
  </Container>
);
